import { useTranslation } from "react-i18next";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import styles from "./styles.module.scss";

export const TypeSelect = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <FormButtonSelect
        placeholder="Select type"
        name={"currentNote.noteType.name"}
        options={[
          {
            label: t("common.noteType.commitment", {
              count: 1,
            }),
            value: DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT,
          },
          {
            label: t("common.noteType.note", {
              count: 1,
            }),
            value: DEFAULT_NOTE_TYPES.DEFAULT_NOTE,
          },
          {
            label: t("common.noteType.idea", {
              count: 1,
            }),
            value: DEFAULT_NOTE_TYPES.DEFAULT_IDEA,
          },
          {
            label: t("common.noteType.meeting", {
              count: 1,
            }),
            value: DEFAULT_NOTE_TYPES.DEFAULT_MEETING,
          },
          {
            label: t("common.noteType.lifeStory", {
              count: 1,
            }),
            value: DEFAULT_NOTE_TYPES.DEFAULT_LIFE_STORY,
          },
        ]}
      />
    </div>
  );
};
